"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CANADA_DEMOGRAPHICS = exports.GEO = void 0;
var types_1 = require("../../types");
var types_2 = require("../types");
var common_1 = require("./common");
var GEO = function (t, languages, settings) {
    var value = types_2.DYNATA_QVALUE.GEO_CA;
    var translateKey = types_2.DYNATA_TRANSLATION_KEYS[value];
    return __assign(__assign({}, (0, common_1.getDefaultQuestion)(t, languages, translateKey, 'GEO - Canada Province', value, t && !!(settings === null || settings === void 0 ? void 0 : settings.questionTexts), { geo: 'province' })), { type: types_1.QTYPES.VECTOR_MAP, selectedRegion: {
            id: 'ca_lcc',
            identifier: 'CA',
            label: 'Canada',
            title: 'Canada',
            value: 'ca_lcc'
        } });
};
exports.GEO = GEO;
var CANADA_DEMOGRAPHICS = function (t, languages, settings) { return [
    (0, common_1.GENDER)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.CA, settings),
    (0, common_1.AGE)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.CA, settings),
    (0, common_1.PERSONAL_CARE_PRODUCTS)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.CA, settings),
    (0, common_1.FINANCIAL_INSURANCE_PRODUCT)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.CA, settings),
    (0, common_1.FINANCIAL_SERVICES)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.CA, settings),
    (0, common_1.FINANCIAL_PRODUCT)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.CA, settings),
    (0, common_1.LANGUAGE_FLUENCY)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.CA, settings),
    (0, common_1.HOUSEHOLD_CHILDREN)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.CA, settings),
    (0, common_1.VEHICLES_IN_HOUSEHOLD)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.CA, settings),
    (0, common_1.EMPLOYMENT_STATUS)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.CA, settings),
    (0, common_1.PETS_IN_HOUSEHOLD)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.CA, settings),
    (0, common_1.NUMBER_OF_CHILDREN)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.CA, settings),
    (0, common_1.NON_ALCOHOLIC_BEVERAGES)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.CA, settings),
    (0, common_1.PRIMARY_VEHICLES)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.CA, settings),
    (0, common_1.HOME_TYPE)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.CA, settings),
    (0, common_1.SEXUAL_ORIENTATION)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.CA, settings),
    (0, common_1.NUMBER_PPL_IN_HOUSEHOLD)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.CA, settings),
    (0, common_1.HOUSEHOLD_GROSS_INCOME)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.CA, settings),
    (0, common_1.RACE_ETHNICITY)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.CA, settings),
    (0, common_1.MARTIAL_STATUS)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.CA, settings),
    (0, common_1.HOUSEHOLD_INVESTABLE_ASSETS)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.CA, settings),
    (0, common_1.EDUCATION)(t, languages, types_2.SUPPORTED_COUNTRY_ISO.CA, settings),
    (0, exports.GEO)(t, languages, settings)
]; };
exports.CANADA_DEMOGRAPHICS = CANADA_DEMOGRAPHICS;
//# sourceMappingURL=CA.js.map